import { ClipboardCheck, ShieldAlert, Video, Users, FileCheck, Plug } from "lucide-react";

// Canonical list of employer/company solution pages — one source of truth for the
// Navbar "For Employers" mega-menu, each page's "Explore more" grid, and footer.
// `icon` holds the lucide component reference (no JSX here — just the identifier).
export const SOLUTION_LINKS = [
  { key: "ai-screening",    label: "AI Screening",      to: "/solutions/ai-screening",    desc: "Invite candidates, AI interviews, ranked shortlist", icon: ClipboardCheck, accent: "#0025D8" },
  { key: "proctoring",      label: "Interview Integrity", to: "/solutions/proctoring",     desc: "9 proctoring signals that flag cheating",            icon: ShieldAlert,    accent: "#E11D48" },
  { key: "video-interviews", label: "Video Interviews", to: "/solutions/video-interviews", desc: "Every interview recorded and replayable",            icon: Video,          accent: "#7C3AED" },
  { key: "talent-pool",     label: "Talent Pool",       to: "/solutions/talent-pool",     desc: "Pipeline candidates and reuse great applicants",     icon: Users,          accent: "#059669" },
  { key: "compliance",      label: "Compliance",        to: "/solutions/compliance",      desc: "Consent, retention & privacy-law coverage",          icon: FileCheck,      accent: "#0F172A" },
  { key: "integrations",    label: "Integrations",      to: "/solutions/integrations",    desc: "Sync with Greenhouse, Lever & Workday",              icon: Plug,           accent: "#0EA5E9" },
];

// Sibling links for a given page key (everything except itself).
export const siblingSolutions = (selfKey) => SOLUTION_LINKS.filter((s) => s.key !== selfKey);

// Shared "Book a demo" CTA — routes to the public demo-request form (the form
// emails sales server-side, so no address is exposed in the frontend).
export const DEMO_CTA = {
  label: "Book a demo",
  href: "/book-demo",
};
